import React, { useCallback } from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import dynamic from 'next/dynamic';

import authDuck from '@/ducks/authDuck.js';
import currentPageNameDuck from '@/ducks/currentPageNameDuck.js';
import interestRateDuck from '@/ducks/interestRateDuck.js';
import invActiveEmailListingDuck from '@/ducks/inv/invActiveEmailListingDuck';
import invActiveInteractionDuck from '@/ducks/inv/invActiveInteractionDuck';
import invResultsDuck from '@/ducks/inv/invResultsDuck';

import EmailOwnerFetcher from '@/fetchers/EmailOwnerFetcher';

// import { ConnectedEmailOwner } from 'reaxl-email';
const ConnectedEmailOwner = dynamic(() => import(
    /* webpackChunkName: "reaxl-email" */
    'reaxl-email'
).then((mod) => mod.ConnectedEmailOwner), { ssr: false });

function InvEmailModalContainer() {

    const dispatch = useDispatch();

    const isLoggedIn = useSelector(authDuck.selectors.isLoggedIn);

    const listing = useSelector(invResultsDuck.selectors.getInvActiveInventory);

    const emailCTAContext = useSelector(invActiveInteractionDuck.selectors.getEmailCTAContext);
    const ownerId = useSelector(invActiveInteractionDuck.selectors.getOwnerId);
    const parentId = useSelector(invActiveInteractionDuck.selectors.getParentId);
    const showEmailModal = useSelector(invActiveInteractionDuck.selectors.getShowEmailModal);
    const showEditEmailModal = useSelector(invActiveInteractionDuck.selectors.getShowEditEmailModal);
    const showEmailConfirmationModal = useSelector(invActiveInteractionDuck.selectors.getShowEmailConfirmationModal);

    const setEmailConfirmationModal = useCallback((state) => {
        dispatch(invActiveInteractionDuck.creators.setKeys({
            showEmailConfirmationModal: state,
        }));
    }, [dispatch]);

    const handleOnHide = () => {
        dispatch(invActiveEmailListingDuck.creators.setActiveResults([listing.id]));

        dispatch(invActiveInteractionDuck.creators.setKeys({
            emailCTAContext: '',
            showEmailModal: false,
            showEditEmailModal: false,
        }));
    };

    const emailOwnerProps = {
        activeEmailListingDuck: invActiveEmailListingDuck,
        ctaProps: {
            onHide: handleOnHide,
            show: showEmailModal,
            context: emailCTAContext,
        },
        currentPageNameDuck,
        fetcher: EmailOwnerFetcher,
        isEditEmailModal: showEditEmailModal,
        isLoggedIn,
        interestRateDuck,
        ownerId,
        parentId,
        setEmailConfirmationModal,
        showEmailConfirmationModal,
        uiContext: 'cta',
    };

    return showEmailModal && (
        <ConnectedEmailOwner
            {...emailOwnerProps}
        />
    );
}

export default InvEmailModalContainer;
